import * as React from 'react';
export const ARSvg = React.forwardRef(function ARSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        d: 'M1.994 0h12.012C15.106 0 16 .895 16 2v2H0V2C0 .888.893 0 1.994 0ZM0 8h16v2c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 4h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 8V4h1v4h-1ZM0 4h1v4H0V4Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 8,
        cy: 6,
        r: 1,
        fill: '#F4B32E',
      }),
    ),
  );
});
ARSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var AR = {
  category: 'flag',
  colorable: false,
  name: 'AR',
  svg: ARSvg,
};
